module.exports = __webpack_public_path__ + "static/media/cherry_tomato_blog_img1.7e7388f3.webp";